import { api, fetcher, wrappedCollectionFetcher } from "services/api.service";
import { defaultKindMovementRule, KindMovementRule } from "types/locationManagement/kindMovementRule";
import { LocationManagementLocationKind } from "types/locationManagement/locationKind";
import { redirect } from "react-router-dom";
import { withActionErrorAlert } from "utils/withActionError";
import { withAuth } from "routes/utils/withAuth";

export const loader = withAuth(async ({ params }: { params: Record<string, string | undefined> }) => {
  let kindMovementRule = defaultKindMovementRule;
  if (params.kindMovementRuleId) {
    const res = await fetcher<KindMovementRule>(
      `/location_management/kind_movement_rules/${params.kindMovementRuleId}`,
    );
    kindMovementRule = res;
  }
  const locationKindsRes = await wrappedCollectionFetcher<LocationManagementLocationKind>(
    "/location_management/location_kinds?page[size]=100",
  );
  const locationKinds = locationKindsRes.rows || [];
  return { kindMovementRule, locationKinds };
});

export async function action({ request, params }: { request: Request; params: Record<string, string | undefined> }) {
  const formData = await request.formData();
  const res = await withActionErrorAlert(() =>
    api.request({
      method: "PUT",
      url: `/location_management/kind_movement_rules/${params.kindMovementRuleId}`,
      data: formData,
      headers: { "Content-Type": "multipart/form-data" },
    }),
  );
  if (res?.status === 200) {
    return redirect("/kind-movements");
  }
  return res;
}
